<template>
  <div class="col-md-3">
    <div class="card">
      <img :src="image" :alt="name" class="card-img-top">
      <div class="card-body">
        <h4 class="card-title">{{ name }}</h4>
        <div class="card-text">QTY: {{ getItemSupply(invId) }}, {{ price | dollars }}</div>
        <div class="row justify-content-end">
           <!-- Credit card payment not ready for sale on line 
          <button class="btn btn-primary" @click="add(invId)">Add to cart</button>
          <button class="btn btn-outline-info" @click="remove(invId)">Remove</button>
           -->       
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import has from 'lodash/has';
import Log from 'loglevel';

export default {
  name: 'item',
  props: ['invId', 'name', 'image', 'price', "quantity"],
  filters: {
      dollars: num => `$${num}`
  },
  computed: {


    itemsInCart: function() {
      // TBD: this code only works for 1 item as it's mixing quantity and number of items
      let cart = this.$store.getters.inCart;
      return cart.reduce((accum, item) => accum + item.quantity, 0);
    },
  },
  methods: {
    getItemSupply(invId) {
      let forSale = this.$store.getters.forSale;
      console.log("items: ", forSale[invId]);
      if (has(forSale[invId], "quantity") ) {
        return forSale[invId].quantity;
      } else {
        return 1;
      }
    },
    add(invId) {
      console.log("add item: ", invId);
      this.$store.dispatch('addToCart', invId);
    },

    remove(invId) {
      console.log("remove item: ", invId);
      this.$store.dispatch('removeFromCart', invId);
    },
  },
};
</script>


// WEBPACK FOOTER //
// Item.vue?1ae59f18